var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "tippy",
        {
          attrs: {
            arrow: "",
            theme: "light-border",
            trigger: "click",
            animateFill: "false",
            interactive: "",
          },
          scopedSlots: _vm._u([
            {
              key: "trigger",
              fn: function () {
                return [
                  _c("div", { staticClass: "c-calendar__card-content" }, [
                    _c(
                      "div",
                      { staticClass: "c-calendar__project-info" },
                      [
                        _c("span", { staticClass: "c-calendar__company" }, [
                          _vm.first_entry.project !== null
                            ? _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.first_entry.project.customer
                                      .company_name
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.first_entry.tour !== null
                            ? _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.first_entry.tour.tour_number)
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _vm.first_entry.project !== null
                          ? [
                              _vm.first_entry.project.address.city
                                ? _c(
                                    "span",
                                    { staticClass: "c-calendar__address" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.first_entry.project.address.city
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.comment
                          ? _c("span", { staticClass: "c-calendar__comment" }, [
                              _c("strong", [_vm._v(_vm._s(_vm.comment))]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "c-calendar__meta-color is-active",
                        }),
                        _vm._v(" "),
                        _vm.isFixed
                          ? _c("span", {
                              staticClass: "c-calendar__meta-color is-fixed",
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.is_holiday
                          ? _c("span", {
                              staticClass: "c-calendar__meta-color is-holiday",
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "c-calendar__count" }, [
                          _c(
                            "span",
                            { staticClass: "c-calendar__count-text" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.count) +
                                  "\n              "
                              ),
                              _vm.count > 1
                                ? [_vm._v(_vm._s(_vm.$t("weeks.entries")))]
                                : [_vm._v(_vm._s(_vm.$t("weeks.entry")))],
                            ],
                            2
                          ),
                        ]),
                      ],
                      2
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("section", { staticClass: "c-calendar__tooltip" }, [
            _c(
              "header",
              {
                staticClass: "grid-x grid-margin-x align-justify align-middle",
              },
              [
                _c("div", { staticClass: "cell auto" }, [
                  _c(
                    "strong",
                    [
                      _vm.count > 1
                        ? [_vm._v(_vm._s(_vm.$t("weeks.entries")))]
                        : [_vm._v(_vm._s(_vm.$t("weeks.entry")))],
                      _vm._v(
                        "\n            (" + _vm._s(_vm.count) + ")\n          "
                      ),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell small-4" }, [
                  _c(
                    "div",
                    { staticClass: "c-calendar__tooltip-edit-button" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "c-calendar__tooltip-edit-button-link button button--action button--action--edit",
                          attrs: {
                            to: {
                              name: "update-day",
                              params: {
                                daily_entries: this.daily_entries,
                                date: this.$moment(this.date).format(
                                  "YYYY-MM-DD"
                                ),
                                kolonne: this.kolonne_number,
                              },
                            },
                            title: _vm.$t("update"),
                          },
                        },
                        [
                          _c("span", { staticClass: "show-for-sr" }, [
                            _vm._v(_vm._s(_vm.$t("update"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "grid-x grid-margin-x" }, [
              _c("div", { staticClass: "cell small-12" }, [
                _c(
                  "div",
                  { staticClass: "c-calendar__tooltip-project-numbers" },
                  _vm._l(_vm.daily_entries, function (entry, index) {
                    return _c(
                      "section",
                      { key: index },
                      [
                        entry.project !== null
                          ? [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "c-calendar__tooltip-project-number",
                                },
                                [_vm._v(_vm._s(entry.project.project_number))]
                              ),
                              _vm._v(" "),
                              _c("v-week-day-content-day-graphic", {
                                attrs: {
                                  numberOfDays: _vm.calcNumberOfDays(entry),
                                },
                              }),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("small", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      entry.project.customer.company_name
                                    ) +
                                    " / " +
                                    _vm._s(entry.project.profile.firstname) +
                                    " " +
                                    _vm._s(entry.project.profile.lastname) +
                                    "\n                  "
                                ),
                                entry.is_date_fixed
                                  ? _c(
                                      "strong",
                                      { staticClass: "u-color--primary" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "weeks.project.is_date_fixed"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        entry.tour !== null
                          ? [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "c-calendar__tooltip-project-number",
                                },
                                [_vm._v(_vm._s(entry.tour.tour_number))]
                              ),
                              _vm._v(" "),
                              _c("v-week-day-content-day-graphic", {
                                attrs: {
                                  numberOfDays: _vm.calcNumberOfDays(entry),
                                },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "grid-x grid-margin-x" }, [
              _c("div", { staticClass: "cell small-12" }, [
                _c("p", { staticClass: "u-no-margin" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("form.comments.comment"))),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell small-10" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editedtext,
                      expression: "editedtext",
                    },
                  ],
                  staticClass: "c-calendar__tooltip-comment",
                  attrs: { name: "comment", type: "text" },
                  domProps: { value: _vm.editedtext },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.editedtext = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell small-2" }, [
                _c("button", {
                  staticClass:
                    "c-calendar__tooltip-save-button button button--action button--action--save",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.saveWeekDay.apply(null, arguments)
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }